import React from 'react'
import { Loader } from 'shpmtcd'
import '../styles/MainLoader.scss'

const MainLoader = () => (
  <div className='shpmtc-loader-modal'>
    <Loader
      transparentCircle
      processText='Processing...'
    />
  </div>
)

export default MainLoader
